import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Document: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.334 1.833H4.333c-.552 0-1 .448-1 1v10.334c0 .552.448 1 1 1h7.334c.552 0 1-.448 1-1V5.167L9.334 1.833Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path
      d="M9.167 2v2.833c0 .368.298.667.666.667h2.834"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
